// extracted by css-extract-rspack-plugin
var _1 = "NSZzT8hPuFkXXdGi";
var _2 = "vwigj3dxywW60BeP";
var _3 = "vwigj3dxywW60BeP";
var _4 = "akeypmguMss7T0pE";
export { _1 as "dialog", _2 as "footer-btn", _3 as "footerBtn", _4 as "header" }
